import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

export function embedComponent (component, mountNode, embedScriptId) {
  const MOUNT_NODE = mountNode
  const scriptTag = document.getElementById(embedScriptId)
  const div = document.createElement('div')

  div.id = MOUNT_NODE

  if (scriptTag) {
    // create stylesheet link tag and insert it into head
    const styleTag = document.createElement("link")
    styleTag.rel = "stylesheet"
    styleTag.type = "text/css"
    styleTag.href = 'https://calculators.bestmoneymoves.com/static/css/app.css'
    styleTag.media = "all"
    document.getElementsByTagName('head')[0].appendChild(styleTag);

    scriptTag.parentNode.insertBefore(div, scriptTag)

    ReactDOM.render(React.createElement(component), document.getElementById(MOUNT_NODE))
    registerServiceWorker()
  }
}



// WEBPACK FOOTER //
// ./src/embed.js